import { Button, Image, useToast } from '@bfe/moly';
import { useCopyToClipboard } from 'react-use';
import Modal from '../Modal';
import { useFm } from '@web3/base-hooks';
import { BlinkData } from '@/types';
import useStore from '@/store';

export default function Blink(props: {
  data: BlinkData | undefined;
  visible: boolean;
  onPost: () => void;
  onCancel: () => void;
}) {
  const [state, copyToClipboard] = useCopyToClipboard();
  const fm = useFm();
  const { data } = props;
  const { toast, EToastType } = useToast();

  const activityChainInfo = useStore((state) => state.activityChainInfo);

  const postUrl =
    `Create your Bybit wallet and share up to 200,000 USDT! ${data?.blinksUrl}&iconIndex=${data?.iconIndex}` ||
    '';

  const title = fm('copy_success');
  const handleCopy = (e: any) => {
    e.stopPropagation();
    state.noUserInteraction && copyToClipboard(postUrl);
    toast({
      iconType: EToastType.SUCCESS,
      title,
    });
  };
  const handlePoster = () => {
    props.onPost();
    window.top?.open(
      `https://x.com/intent/post?text=&url=${encodeURIComponent(postUrl)}`
    );
  };

  return (
    <Modal
      visible={props.visible}
      size="small"
      title={fm('yourBlinkUrl')}
      cancelText={false}
      onCancel={props.onCancel}
      footer={
        <div className="flex justify-between gap-6 px-2">
          <Button
            className="w-1/2 !h-12 !rounded-lg"
            variant="secondary"
            data-spm-even="Web3UserClick"
            data-spm-data={JSON.stringify({
              button_name: 'airdrop_task_blink_copy',
              blinksUrl: data?.blinksUrl,
              wallet_address: activityChainInfo?.address,
            })}
            onClick={(e) => handleCopy(e)}
          >
            {fm('copyBlinkUrl')}
          </Button>
          <Button
            className="w-1/2 !h-12 !rounded-lg"
            variant="primary"
            data-spm-even="Web3UserClick"
            data-spm-data={JSON.stringify({
              button_name: 'airdrop_task_blink_post',
              blinksUrl: data?.blinksUrl,
              wallet_address: activityChainInfo?.address,
            })}
            onClick={handlePoster}
          >
            {fm('postTwitter')}
          </Button>
        </div>
      }
    >
      <div className="text-left px-2">
        <p className="mt-1 text-sm font-semibold">
          Share this Blink now to boost the prize!
        </p>
        <Image
          src={data?.icon ?? ''}
          width={416}
          height={416}
          loading="lazy"
          className="rounded mt-4"
        ></Image>
      </div>
    </Modal>
  );
}
